module.exports = __webpack_public_path__ + "img/wolfhound2.f5471afe.jpg";